import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { HELP_CENTER_IDS } from "../_constants/help-center.ids";

interface SectionHeaderProps {
  title: string;
  subtitle: string;
}

export function SectionHeader({ title, subtitle }: SectionHeaderProps) {
  return (
    <Box
      id={HELP_CENTER_IDS.sectionHeader.root}
      bg="linear-gradient(180deg, rgba(99,91,255,0.06) 0%, rgba(250,248,245,0) 100%)"
    >
      <Container
        id={HELP_CENTER_IDS.sectionHeader.container}
        maxW="full"
        px={{ base: 5, md: 0 }}
        bg="primary.500"
      >
        <Flex
          id={HELP_CENTER_IDS.sectionHeader.content}
          direction="column"
          align="start"
          gap={3}
          pb={{ base: 8, md: 14 }}
          pt={{ base: "2rem", md: "3.25rem" }}
          maxW="1350px"
          mx="auto"
        >
          <Text
            id={HELP_CENTER_IDS.sectionHeader.title}
            fontFamily="heading"
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="bold"
            color="neutral.50"
            letterSpacing="-0.5px"
            lineHeight={1.1}
          >
            {title}
          </Text>
          <Text
            id={HELP_CENTER_IDS.sectionHeader.subtitle}
            fontSize={{ base: "sm", md: "md" }}
            color="neutral.50"
            maxW="500px"
            lineHeight={1.7}
          >
            {subtitle}
          </Text>
        </Flex>
      </Container>
    </Box>
  );
}
